interface ReservedSlot {
    id: string;
    level: number;
}

const _reservedSlots: ReservedSlot[] = [];

// modalId → zIndex du modal, pour que le MutationObserver sache quel zIndex assigner au backdrop
const _pendingBackdrops: Map<string, number> = new Map();

/**
 * Pré-réserve les niveaux de stack pour plusieurs modals à ouvrir simultanément.
 * Les selectors sont passés dans l'ordre d'empilement voulu (le dernier sera visible au dessus).
 * Les modals déjà ouverts conservent leur position.
 *
 * @example
 * openModals("#VehiculeViewModal", "#ScheduleViewModal");
 * vehiculeController.view(id);          // ouvre #VehiculeViewModal
 * scheduleController.view(scheduleId);  // ouvre #ScheduleViewModal — sera au dessus
 */
export function openModals(...selectors: string[]): void {
    const baseLevel = $(".modal.show").length;
    selectors.forEach((selector, index) => {
        const el = document.querySelector(selector) as HTMLElement | null;
        if (el?.id) {
            _reservedSlots.push({ id: el.id, level: baseLevel + index + 1 });
        }
    });
}

// Tague chaque backdrop dès son insertion dans le DOM avec le zIndex du modal qui l'a créé.
// Garantit l'association correcte même quand plusieurs modals s'ouvrent en parallèle.
const backdropObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
            if (node instanceof HTMLElement && node.classList.contains("modal-backdrop")) {
                for (const [modalId, zIndex] of _pendingBackdrops) {
                    node.style.zIndex = `${zIndex - 1}`;
                    node.setAttribute("data-modal-stack", modalId);
                    _pendingBackdrops.delete(modalId);
                    break;
                }
            }
        }
    }
});

backdropObserver.observe(document.body, { childList: true });

$(function () {
    document.querySelectorAll(".modal").forEach((e) => {
        // show.bs.modal : assigne le zIndex du modal et enregistre le backdrop attendu
        e.addEventListener("show.bs.modal", (ev) => {
            const id = (ev.target as HTMLElement).id;
            const reservedIndex = _reservedSlots.findIndex((s) => s.id === id);
            const level = reservedIndex >= 0 ? _reservedSlots[reservedIndex].level : $(".modal.show").length + 1;

            const zIndex = 1000 + 3 * level;
            $(ev.target as HTMLElement).css("z-index", `${zIndex}`);
            _pendingBackdrops.set(id, zIndex);
        });

        // shown.bs.modal : libère le slot réservé (zIndex déjà posé sur show.bs.modal)
        e.addEventListener("shown.bs.modal", (ev) => {
            const id = (ev.target as HTMLElement).id;
            const reservedIndex = _reservedSlots.findIndex((s) => s.id === id);
            if (reservedIndex >= 0) {
                _reservedSlots.splice(reservedIndex, 1);
            }
        });
    });
});
